import { createRouter, createWebHistory } from 'vue-router'
import Vue from 'vue'

import index from './components/pages/index.vue'
import contract from './components/pages/documents/contract.vue'
import invoice from './components/pages/documents/invoice.vue'
import act from './components/pages/documents/act.vue'
import search from './components/pages/documents/search.vue'


const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    // mode: 'history',
  	routes: [
		{
			path: '/documents/contract/:id',
			name: 'contract',
			component: contract
		},
		{
			path: '/documents/:id',
			name: 'index',
			component: index
		},		
		{
			path: '/documents/invoice/:id',
			name: 'invoice',
			component: invoice
		},		
		{
			path: '/documents/act/:id',
			name: 'act',
			component: act
		},		
		{
			path: '/',
			name: 'main',
			component: index
		},
		{
			path: '/documents/search',
			name: 'search',
			component: search
		},
	]
})

export default router